import { ComboboxItemPrice } from "~/types";

function isLabArray(
  arr: (string | ComboboxItemPrice)[]
): arr is ComboboxItemPrice[] {
  return typeof arr[0] === "object" && "price" in arr[0] && "value" in arr[0];
}

export const getLabsSubTotal = (
  selectedLabs: string[] | ComboboxItemPrice[],
  allLabs?: ComboboxItemPrice[]
) => {
  if (selectedLabs.length === 0) return 0;

  if (isLabArray(selectedLabs)) {
    // console.log("selected lab:", selectedLabs);
    return selectedLabs.reduce((acc, lab) => acc + (lab.price ?? 0), 0);
  }

  return selectedLabs.reduce((acc, value) => {
    const foundLab = allLabs?.find(item => item.value === value);
    // console.log("found lab:", acc);
    return foundLab ? acc + (foundLab.price ?? 0) : acc;
  }, 0);
};
